import { mapGetters } from 'vuex';
import adminMixin from 'dashboard/mixins/isAdmin';
import { isLabelVisibleForUser } from 'dashboard/helper/labelVisibility';

// Marcadores que o usuário logado pode usar fora do contexto de uma conversa:
// admin vê todos; agente vê os de sistema e os das suas equipes/caixas.
export default {
  mixins: [adminMixin],
  computed: {
    ...mapGetters({
      accountLabels: 'labels/getLabels',
      userTeams: 'teams/getMyTeams',
      userInboxes: 'inboxes/getInboxes',
    }),
    labelUserContext() {
      return {
        isAdmin: this.isAdmin,
        teamIds: this.userTeams.map(team => team.id),
        inboxIds: this.userInboxes.map(inbox => inbox.id),
      };
    },
    userVisibleLabels() {
      return this.accountLabels.filter(this.isLabelVisibleToCurrentUser);
    },
  },
  methods: {
    isLabelVisibleToCurrentUser(label) {
      return isLabelVisibleForUser(label, this.labelUserContext);
    },
  },
};
